var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStormRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.993 28.644C116.993 28.644 116.523 26.907 116.477 26.4C116.43 25.893 115.398 23.7105 114.603 22.2975C113.808 20.8845 112.112 19.0995 111.255 18.3795C110.399 17.658 107.585 17.481 107.585 17.481L103.676 17.589H94.6714C94.6714 17.589 89.7334 17.4615 89.5159 17.43C89.2984 17.4 85.5784 16.725 84.9724 16.674C84.3664 16.623 84.0409 17.1615 83.4754 17.5305C82.9084 17.8995 82.2274 17.7285 82.2274 17.7285L80.3404 17.298C80.3404 17.298 80.8189 16.983 81.1054 16.5645C81.3919 16.1475 81.1054 15.504 81.1054 15.504C81.1054 15.504 80.1424 13.7145 79.8109 13.188C79.4794 12.6615 78.6079 12.435 77.5894 12.4425C76.5709 12.4485 73.3924 12.789 72.2344 12.9015C71.0764 13.014 65.2489 13.851 65.2489 13.851C65.2489 13.851 57.4999 15.4095 54.7069 15.7965C51.9139 16.1835 45.2899 16.2885 45.2899 16.2885C45.2899 16.2885 36.8164 16.482 34.3654 17.2995C31.9159 18.117 30.6919 20.1675 30.6919 20.1675L31.9804 21.7785L33.2689 21.8295L35.2639 22.668L43.1614 22.827L43.7014 23.907H10.1614L7.99988 24.738L5.13188 24.438L2.59688 25.2045L2.09888 26.8995L2.77988 27.465L2.09888 28.188L2.46038 28.8465L4.10888 29.877L7.66838 29.9745L10.6054 30.8475H38.8399L40.3144 31.6965L36.9649 32.457C36.9649 32.457 36.4324 34.401 37.0009 35.265C37.5694 36.129 41.9419 37.2825 41.9419 37.2825L47.5669 38.565L48.5089 38.412L49.1179 38.766L50.5339 38.3205L51.8539 38.808C51.8539 38.808 52.8709 38.481 53.0524 38.565C53.2339 38.6475 53.8564 38.898 53.8564 38.898L54.8809 38.6625L55.5319 39.072C55.5319 39.072 65.0524 40.551 66.7669 40.9245C68.4814 41.298 73.5004 42.8595 73.5004 42.8595C73.5004 42.8595 73.9654 43.86 74.3884 44.172C74.8099 44.484 75.4504 43.857 75.4504 43.857C75.4504 43.857 76.8244 44.3085 77.6599 44.358C78.4954 44.4075 79.9024 43.857 79.9024 43.857H83.1079L84.2254 42.777C84.2254 42.777 88.0744 42.294 89.2429 41.925C90.4114 41.556 92.9194 40.4085 92.9194 40.4085L98.5414 38.121L100.169 37.86L103.614 38.526C103.614 38.526 108.803 39.189 110.235 39.0915C111.668 38.9955 112.65 38.1285 112.65 38.1285C112.65 38.1285 116.463 32.616 116.667 31.8315C116.871 31.047 116.393 29.976 116.393 29.976L116.991 28.647L116.993 28.644ZM85.1809 37.9125C84.1009 38.2455 83.4769 37.0395 83.4769 37.0395C83.4769 37.0395 81.1909 31.803 81.1909 31.6365C81.1909 31.6365 79.6954 29.9325 79.8199 28.392C79.9444 26.8515 81.1084 26.151 81.9394 25.9005C82.7704 25.6515 84.4324 25.2765 84.7654 27.0645C85.0984 28.851 82.8949 29.3505 82.8949 29.3505L84.8074 33.6735C84.8074 33.6735 86.0134 34.047 86.3029 35.1285C86.5939 36.2085 86.2609 37.581 85.1809 37.9125ZM107.25 32.343C107.25 32.343 96.0709 32.343 94.9474 32.1345C93.8254 31.926 93.1189 30.4305 92.6614 29.5575C92.2039 28.6845 91.5394 28.3905 91.5394 28.3905C91.5394 28.3905 88.2139 25.5675 88.0069 25.1925C87.7984 24.819 87.3829 23.5305 88.3399 22.9485C89.2954 22.3665 90.1684 23.4885 90.1684 23.4885L93.1609 25.857L93.5764 26.646L95.2384 26.8125L96.0274 26.2305L107.042 26.2725L108.122 27.0615C108.122 27.0615 107.457 27.519 107.457 27.8925C107.457 28.266 107.831 28.842 107.831 28.842C107.831 28.842 107.498 29.2215 107.582 29.721C107.664 30.219 108.704 30.552 108.704 30.552L107.249 32.3385L107.25 32.343Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0311 41.3069C84.0311 41.3069 80.6366 40.5089 79.8116 37.9709C78.9881 35.4329 79.5416 28.4549 79.5416 28.4549",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8811 31.2225L70.3986 36.708",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3459 25.0198L58.207 26.5663L75.7224 28.3918",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.725 35.607L72.8915 36.375L57.542 31.2225L58.151 28.8465L72.6155 30.6675L75.995 32.94",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77856 27.564H56.1696L72.6156 29.7255",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6296 24.438C55.6296 24.438 55.9626 23.406 55.2141 22.7835C55.2141 22.7835 56.7096 22.245 57.5421 20.706C58.3746 19.167 58.0401 17.505 59.9946 16.425C61.9476 15.345 67.4346 13.6815 67.4346 13.6815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6204 38.2049C48.6204 38.2049 49.3269 38.0384 49.8264 36.8339C50.0799 36.2219 50.1309 35.9894 50.3664 35.9474C50.6019 35.9054 50.8644 37.1534 50.3664 38.0669",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6494 38.4119C50.6494 38.4119 51.3559 38.2454 51.8554 37.0409C52.1089 36.4289 52.1599 36.1964 52.3954 36.1544C52.6309 36.1124 52.8934 37.3604 52.3954 38.2739",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.678 38.565C52.678 38.565 53.3845 38.3985 53.884 37.194C54.1375 36.582 54.1885 36.3495 54.424 36.3075C54.6595 36.2655 54.922 37.5135 54.424 38.427",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7981 38.7659C54.7981 38.7659 55.5046 38.5994 56.0041 37.3949C56.2576 36.7829 56.3086 36.5504 56.5441 36.5084C56.7796 36.4664 57.0421 37.7144 56.5441 38.6279",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5149 38.6609C68.5149 38.6609 71.2584 40.947 71.7159 42.1515",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.206 27.024L113.152 27.1065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.873 28.728L111.947 28.8465L113.152 27.564L111.947 28.8465L113.858 30.6405H108.704",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.948 28.8465H116.727",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1809 19.5436C78.1809 19.5436 79.3989 20.6656 79.3599 21.5806C79.3209 22.4956 78.7704 23.8666 78.7704 23.8666L79.5699 24.4381C79.5699 24.4381 86.3859 23.2846 86.6769 21.7456C86.9679 20.2066 78.1809 19.5421 78.1809 19.5421V19.5436Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8176 20.2635C78.8176 20.2635 79.8601 20.313 80.1721 20.4375C80.4841 20.562 80.8156 21.2685 80.6701 22.3695C80.5246 23.4705 80.1391 24.333 80.1391 24.333",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.678 21.4275H81.7925C81.7925 21.4275 82.3325 21.414 82.208 22.557C82.0835 23.7 82.094 23.9085 82.094 23.9085",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8111 17.2979C79.8111 17.2979 78.2391 18.1289 74.6646 18.7934L71.0901 19.4579",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5051 22.779L50.1081 21.942",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.915 20.892L51.518 20.0535",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.915 22.956L51.518 22.1175",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3254 21.069L52.9269 20.2305",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.085 17.8665C91.085 17.8665 94.949 19.002 96.833 19.4595C98.717 19.917 102.485 20.1645 104.093 20.262C105.701 20.3595 108.387 19.6665 110.867 20.706C113.346 21.7455 116.145 25.6875 116.145 25.6875",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3528 20.7059C66.3528 20.7059 75.9948 18.8639 80.6778 18.6419C85.3608 18.4199 85.1388 18.5864 85.2498 17.8664C85.3608 17.1464 84.9723 16.6754 84.9723 16.6754",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.25 32.3445L110.865 34.4775",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M110.68 30.6404L108.704 33.0509L107 25.8599H109.328L110.68 27.0659",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6545 35.6069L96.7765 34.8809H98.938L100.518 35.6069",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7688 32.6114L72.4208 33.9644",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4575 25.86C74.4575 25.86 74.7065 29.2065 74.666 30.837C74.624 32.469 74.6105 34.113 73.751 35.244C72.8915 36.375 70.634 39.0765 70.634 39.0765",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0979 26.8996L2.5959 25.2045L4.5909 24.738H7.9989L10.1604 23.9071H45.5709L43.1604 22.827H34.5984L33.2679 21.8295H32.0214L30.6909 20.1675C30.6909 20.1675 32.1864 17.8395 35.0139 17.0925C37.8399 16.344 47.8989 16.2616 51.3069 16.0951C54.7149 15.9286 59.5359 15.1801 62.8614 14.349C66.1869 13.518 72.2544 12.8535 74.6649 12.687C77.0754 12.5205 78.8214 12.189 79.4034 12.687C79.9854 13.185 81.2319 15.762 81.2319 15.762C81.2319 15.762 81.3984 16.926 80.2344 17.3415C80.2344 17.3415 82.2294 17.8395 82.8939 17.757C83.5584 17.6745 84.3894 16.7595 84.9714 16.677C85.5534 16.5945 89.2944 17.592 91.2894 17.592H103.675C103.675 17.592 107.498 17.259 109.327 17.6745C111.155 18.09 111.571 18.423 113.15 20.2515C114.73 22.08 116.392 25.4881 116.476 26.4031L116.558 27.318L117.056 28.8496L116.392 29.9776C116.392 29.9776 116.89 31.4746 116.558 32.3881C116.227 33.3016 114.314 36.2116 113.233 37.4581C112.153 38.7046 112.153 38.871 109.991 39.12C107.83 39.369 106.084 38.8711 104.255 38.6221C102.427 38.3731 99.8499 37.7911 99.8499 37.7911C99.8499 37.7911 97.3569 38.289 94.7799 39.537C92.2029 40.7835 89.2944 42.0301 87.7974 42.3631C86.3019 42.6961 84.2229 42.7786 84.2229 42.7786L83.2254 43.8586H79.8999C79.8999 43.8586 78.3204 44.4406 77.2404 44.3566C76.1604 44.2741 75.0789 43.8586 75.0789 43.8586C75.0789 43.8586 74.4144 44.4406 74.0814 44.0251C73.7484 43.6096 73.4994 42.8611 73.4994 42.8611C73.4994 42.8611 67.9299 40.9486 63.5244 40.2841C59.1189 39.6196 55.2954 39.0376 55.2954 39.0376L54.9624 38.4001C54.9624 38.4001 54.1869 38.8441 53.8539 38.8981C53.5209 38.9536 52.9944 38.4001 52.9944 38.4001C52.9944 38.4001 52.4409 38.7885 51.7749 38.8155C51.1104 38.8425 50.7774 38.1511 50.7774 38.1511C50.7774 38.1511 50.0844 38.7046 49.3914 38.7601C48.6984 38.8156 48.5604 38.2621 48.5604 38.2621C48.5604 38.2621 47.7849 38.5666 47.6454 38.6221C47.5059 38.6776 41.0784 37.2091 41.0784 37.2091C41.0784 37.2091 37.2129 35.8786 36.5904 34.8406C35.9664 33.8011 37.0884 32.2636 37.0884 32.2636L41.1204 31.5571L39.2079 30.8505H10.2444L7.6674 29.9776H4.4259L2.8044 29.4795L2.0979 28.1911C2.0979 28.1911 2.7414 27.9 2.7834 27.5475C2.8254 27.1935 2.0979 26.904 2.0979 26.904V26.8996Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1911 31.6381C81.1911 31.8046 83.4771 37.0411 83.4771 37.0411C83.4771 37.0411 84.1011 38.2471 85.1811 37.9141C86.2611 37.5811 86.5941 36.2101 86.3031 35.1301C86.0121 34.0501 84.8076 33.6751 84.8076 33.6751L82.8951 29.3521C82.8951 29.3521 85.0986 28.8541 84.7656 27.0661C84.4326 25.2796 82.7706 25.6531 81.9396 25.9021C81.1086 26.1511 79.9446 26.8516 79.8201 28.3936C79.6956 29.9356 81.1911 31.6381 81.1911 31.6381V31.6381Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5768 26.6506L93.1613 25.8616L90.1688 23.4931C90.1688 23.4931 89.2958 22.3711 88.3403 22.9531C87.3848 23.5351 87.8003 24.8236 88.0073 25.1971C88.2143 25.5706 91.5398 28.3951 91.5398 28.3951C91.5398 28.3951 92.2043 28.6891 92.6618 29.5621C93.1193 30.4351 93.8258 31.9306 94.9478 32.1391C96.0698 32.3476 107.251 32.3476 107.251 32.3476L108.706 30.5611C108.706 30.5611 107.666 30.2281 107.584 29.7301C107.501 29.2321 107.833 28.8511 107.833 28.8511C107.833 28.8511 107.459 28.2751 107.459 27.9016C107.459 27.5281 108.124 27.0706 108.124 27.0706L107.044 26.2816L96.0293 26.2396L95.2403 26.8216L93.5783 26.6551L93.5768 26.6506Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.393 29.9745H114.647C114.647 29.9745 113.65 30.0585 113.567 30.5985C113.485 31.1385 113.11 32.3445 113.11 32.3445L110.575 34.755C110.575 34.755 110.035 35.835 107.831 35.877C105.628 35.919 100.433 35.877 100.433 35.877C100.433 35.877 100.351 36.501 99.7268 36.5835C99.1028 36.666 96.7763 36.5835 96.7763 36.5835C96.7763 36.5835 95.6543 36.708 95.6963 35.919L94.2413 35.877C94.2413 35.877 92.7038 35.628 91.3733 37.3725C90.0428 39.1185 87.9233 40.2405 87.0503 40.5315C86.1773 40.8225 84.3908 41.0295 84.0578 41.28C83.7248 41.5305 84.2243 42.7755 84.2243 42.7755",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.144 27.3151C116.144 27.3151 115.687 27.9391 115.229 28.1461C114.772 28.3546 113.068 27.0241 113.068 27.0241L112.819 25.6891L110.326 22.9516L99.893 22.7836C99.893 22.7836 95.114 25.0711 94.9055 25.0291C94.697 24.9871 91.1645 21.9946 91.1645 21.9946C91.1645 21.9946 89.627 20.7061 88.2545 21.5791C86.8835 22.4521 87.3815 25.0696 87.3815 25.0696C87.3815 25.0696 87.332 26.0251 86.4005 25.2781C85.469 24.5296 81.8525 23.5636 79.9415 25.6891L79.1525 26.2351L76.3685 26.4436C76.3685 26.4436 75.953 25.9036 75.704 25.8616C75.455 25.8196 55.6715 24.9466 55.6715 24.9466L55.1735 25.6891C55.1735 25.6891 53.9675 25.7251 53.7605 25.6891C53.552 25.6531 53.969 25.5286 53.7605 24.9046C53.552 24.2806 52.721 23.4916 52.805 23.1586C52.889 22.8256 64.3175 20.7061 64.3175 20.7061",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5725 23.907H48.1495L49.438 24.438H53.344",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.511 33.4455H42.2875L44.2405 31.2225H54.2575C54.2575 31.2225 54.175 32.469 55.837 33.4455C57.499 34.422 67.558 38.5785 67.558 38.5785H68.431L72.7945 39.9915L74.332 39.1605L75.5785 35.607H78.1135V39.9915C78.1135 39.9915 78.487 41.571 77.449 41.9445C76.4095 42.318 75.496 42.2355 75.496 42.2355L75.0805 43.857",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5803 35.6072L75.9133 32.8427L76.7863 32.0942V29.9747L76.1203 29.2682L74.6653 26.0687",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1721 25.689C55.1721 25.689 56.1696 26.193 56.1696 27.8145C56.1696 29.436 55.3806 31.2225 54.2571 31.2225",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4039 25.278C86.4039 25.278 87.4119 26.1225 87.1899 27.564C87.1899 27.564 90.4599 27.5715 91.0134 30.837C91.5669 34.1025 88.7079 34.8795 88.7079 34.8795C88.7079 34.8795 89.0589 36.819 87.7359 38.205C86.4129 39.591 84.4584 38.5485 83.8569 37.5405",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormRifle);
export default __webpack_public_path__ + "static/media/Storm Rifle.d65cdda3d444098432179df026f3d422.svg";
export { ForwardRef as ReactComponent };